import UsersDetails from './UsersDetails';

export default UsersDetails;
